import { AddEditFormModalProps } from './AddEditFormModal';
import { openModal } from '@core/components/ModalStack';

export async function openAddEditFormModal(props: AddEditFormModalProps) {
  const { AddEditFormModal } = await import('./AddEditFormModal');

  openModal(AddEditFormModal, props);
}
